import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from '../actions';
import {connect} from 'react-redux';

class RemoveCheckedLineups extends Component {
    onClick() {
        this.props.dispatch(Action.do('removeCheckedLineups'));
    }

    render() {
        const {sportConfig, className = '', children = null} = this.props;

        if (sportConfig.isModeLateswap()) {
            return null;
        }

        return (
            <button type="button" className={className} onClick={(e) => ::this.onClick()}>
                {children}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

export default connect(mapStatesToProps)(RemoveCheckedLineups);
